import IconButton from 'lib/components/buttons/icon-button'
import Button from 'components/core/button'
import { X, Plus, Minus } from 'lucide-react'
import { cn } from 'lib/util/cn'

interface BillingModalCreativeServicesProps {
  designHours: number
  setDesignHours: (value: number) => void
  period: string
}

export default function BillingModalCreativeServices({
  designHours,
  setDesignHours,
  period,
}: BillingModalCreativeServicesProps) {
  return (
    <div>
      <div
        className={cn(
          'tw-mt-2 tw-flex tw-h-[4.5rem] tw-justify-between tw-rounded tw-border tw-border-solid tw-p-4',
          designHours > 0 ? 'tw-border-cornflower-300 tw-bg-neutral-50' : 'tw-border-neutral-200',
        )}
      >
        <div className="tw-flex tw-items-center tw-gap-2">
          {designHours > 0 && (
            <div className="tw-align-items tw-flex">
              <IconButton
                color="secondary"
                size="xs"
                onClick={() => setDesignHours(designHours === 2 ? 0 : designHours - 1)}
                data-testid="minus"
              >
                <Minus />
              </IconButton>
              <div className="tw-w-8 tw-px-2 tw-text-center tw-text-lg">{designHours}</div>
              <IconButton
                color="secondary"
                size="xs"
                onClick={() => designHours < 8 && setDesignHours(designHours + 1)}
                data-testid="plus"
              >
                <Plus />
              </IconButton>
            </div>
          )}
          <div>
            <div className="tw-font-semibold tw-text-peppercorn-900">Creative services</div>
            <div>2 daily design hours up to 40 hours per month </div>
          </div>
        </div>
        {designHours > 0 ? (
          <IconButton color="secondary" onClick={() => setDesignHours(0)}>
            <X />
          </IconButton>
        ) : (
          <div className="tw-flex tw-items-center">
            <div>
              <div className="tw-font-semibold tw-text-peppercorn-900">+$399.00</div>
              <div>billed {period}</div>
            </div>
            <Button
              color="neutral"
              className="tw-ml-2"
              onClick={() => {
                setDesignHours(2)
              }}
            >
              <Plus />
              Add
            </Button>
          </div>
        )}
      </div>
    </div>
  )
}
